import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import SmoothScroll from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { Manifesto } from "@/components/site/Manifesto";
import { BusinessModel } from "@/components/site/BusinessModel";
import { Financials } from "@/components/site/Financials";
import { MarketValidation } from "@/components/site/MarketValidation";
import { TheNote } from "@/components/site/TheNote";
import { EquityOption } from "@/components/site/EquityOption";
import { Traction } from "@/components/site/Traction";
import { Team } from "@/components/site/Team";
import { FAQ } from "@/components/site/FAQ";
import { StickyInvestBar } from "@/components/site/StickyInvestBar";
import { Contact } from "@/components/site/Contact";

export default function Landing() {
  const agreed = sessionStorage.getItem("epic_agreed") === "true";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!agreed) return <Navigate to="/" replace />;

  return (
    <SmoothScroll>
      <div data-testid="landing-page" className="relative bg-epic-bg">
        <Header />
        <main>
          <Hero />
          <MarqueeStrip />
          <Manifesto />
          <BusinessModel />
          <Financials />
          <MarketValidation />
          <TheNote />
          <EquityOption />
          <Traction />
          <Team />
          <FAQ />
          <Contact />
          <StickyInvestBar />
        </main>
      </div>
    </SmoothScroll>
  );
}
